module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.clickOutside),
      expression: "clickOutside"
    }],
    class: ['v-select', _vm.sizeClass]
  }, [_c('dt', {
    staticClass: "v-select-dt"
  }, [_c('a', {
    staticClass: "v-select-selected",
    style: ({
      'width': _vm.width + 'px'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.toggleItems()
      }
    }
  }, [(_vm.isInput) ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "v-select-input",
    attrs: {
      "placeholder": _vm.placeholder,
      "type": "text"
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  })] : [_c('span', {
    staticClass: "v-select-selected-span"
  }, [_vm._v(_vm._s(_vm.showSelectInfo()))])], _vm._v(" "), _c('i', {
    staticClass: "v-select-selected-i v-icon-down-dir"
  })], 2)]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "v-select-dd"
  }, [_c('ul', {
    staticClass: "v-select-items",
    style: ({
      'min-width': _vm.width + 'px',
      'max-width': _vm.getMaxWidth + 'px'
    })
  }, _vm._l((_vm.internalOptions), function(item) {
    return _c('li', {
      class: ['v-select-items-li', item.selected ? 'active' : ''],
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.selectOptionClick(item)
        }
      }
    }, [_c('a', {
      class: ['v-select-items-li-a', _vm.getTextAlignClass()],
      attrs: {
        "href": "javascript:void(0);"
      }
    }, [_vm._v(_vm._s(item.label))])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e546174"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-easytable/libs/v-select/src/select.vue
// module id = 548
// module chunks = 84